import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import React from 'react';
import {StyledHeaderCell} from '../StyledHeaderCell';
import {BoxTraceTableRow} from "./BoxTraceTableRow";

export const BoxTraceTable = ({traces}) => <Table
    size="small"
    sx={{
        border: '1px solid grey',
        mb: 3,
    }}
>
    <TableHead>
        <TableRow>
            <StyledHeaderCell>Product</StyledHeaderCell>
            <StyledHeaderCell>Box</StyledHeaderCell>
            <StyledHeaderCell>Action</StyledHeaderCell>
            <StyledHeaderCell>Block</StyledHeaderCell>
            <StyledHeaderCell>Created</StyledHeaderCell>
        </TableRow>
    </TableHead>
    <TableBody>
        {traces.map(trace => <BoxTraceTableRow key={trace.id} trace={trace}/>)}
    </TableBody>
</Table>;
